import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId80001: SiteIdOverrideConfig = {
  flight: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.travelocity.label.flight",
      locSubtitleTextToken: "wizard.travelocity.subLabel.flight",
      differentiatedTitles: false,
    },
  },
  package: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.travelocity.label.packages",
      locSubtitleTextToken: "wizard.travelocity.subLabel.packages",
      differentiatedTitles: true,
    },
    lobLabels: {
      hotelsLabel: "wizard.Comet.hotel.tab.title.label",
    },
  },
  hotel: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.travelocity.label.hotel",
      locSubtitleTextToken: "wizard.travelocity.subLabel.hotel",
      locTitleToken: "wizard.hotel.pwa.expand.icon.title",
      differentiatedTitles: false,
    },
    navigation: {
      tabTitleToken: "wizard.Comet.hotel.tab.title.label",
    },
  },
  lx: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.travelocity.label.Activities",
      locSubtitleTextToken: "wizard.travelocity.subLabel.Activities",
      differentiatedTitles: false,
    },
  },
  car: {
    date: {
      maxDaysRange: 329,
    },
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.travelocity.label.Cars",
      locSubtitleTextToken: "wizard.travelocity.subLabel.Cars",
      differentiatedTitles: true,
    },
    AARPCheckbox: true,
  },
  cruise: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.travelocity.label.Cruises",
      differentiatedTitles: false,
      visibleLobSubtitle: true,
      locSubtitleVariant: "1-855-257-1605",
    },
  },
};
